import React from "react";
import {
  Create,
  SimpleForm, 
  useUpdate,
  AutocompleteInput
} from "react-admin";
import Wrapper from "../styles/most-visited/MostVisitedCreate";
import modal from "../../assets/modal.png";

const MostSearchedCreate = (props) => {
  const arr =  props.stores; 
  const storesFiltered = arr.filter((el)=> el.isDeleted !== true && el.isVerified === true );

 
  const [update] = useUpdate();
  const postSave = (data) => {
    console.log(data);
   const storeId = data.id;
   
    update("ordering/addStore",{ id: storeId,data:{orderTypeId:2, position:2}} );   
    props.onAddStore();
     
  };
 
  return (
    <Wrapper>
      <div className="modal-top">
        <img src={modal} alt="modal" />
        <span>Add Store</span>
      </div>
      <Create className="test" sx={{ width: 480 }} mutationMode="optimistic">
        <SimpleForm onSubmit={postSave}>
          <AutocompleteInput    source="id" choices={storesFiltered} label="Name"/>
        </SimpleForm>
      </Create>
    </Wrapper>
  );
};
export default MostSearchedCreate;